document.addEventListener('DOMContentLoaded', function () {
	var h1Input = document.querySelector('.wpcf7 input[name="page_h1"]')
	var urlInput = document.querySelector('.wpcf7 input[name="page_url"]')
	if (h1Input) h1Input.value = document.title
	if (urlInput) urlInput.value = window.location.href
})
